import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.element.style.opacity = "1";
        this.element.style.display = "block";
        
        setTimeout(() => {
            this.element.style.transition = "opacity 0.5s";
            this.element.style.opacity = "0";
            setTimeout(() => {
                this.element.style.display = "none";
                this.element.remove();
            }, 500);
        }, 4000);
    }
}   
